/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.85
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LoyaltyRedemptionStatus } from './LoyaltyRedemptionStatus';
import {
    LoyaltyRedemptionStatusFromJSON,
    LoyaltyRedemptionStatusFromJSONTyped,
    LoyaltyRedemptionStatusToJSON,
} from './LoyaltyRedemptionStatus';

/**
 * 
 * @export
 * @interface SpinHistoryFilters
 */
export interface SpinHistoryFilters {
    /**
     * 
     * @type {Date}
     * @memberof SpinHistoryFilters
     */
    endDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof SpinHistoryFilters
     */
    startDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof SpinHistoryFilters
     */
    resultEnd?: number;
    /**
     * 
     * @type {number}
     * @memberof SpinHistoryFilters
     */
    resultStart?: number;
    /**
     * 
     * @type {LoyaltyRedemptionStatus}
     * @memberof SpinHistoryFilters
     */
    status?: LoyaltyRedemptionStatus;
    /**
     * 
     * @type {string}
     * @memberof SpinHistoryFilters
     */
    gameId?: string;
}



/**
 * Check if a given object implements the SpinHistoryFilters interface.
 */
export function instanceOfSpinHistoryFilters(value: object): value is SpinHistoryFilters {
    return true;
}

export function SpinHistoryFiltersFromJSON(json: any): SpinHistoryFilters {
    return SpinHistoryFiltersFromJSONTyped(json, false);
}

export function SpinHistoryFiltersFromJSONTyped(json: any, ignoreDiscriminator: boolean): SpinHistoryFilters {
    if (json == null) {
        return json;
    }
    return {
        
        'endDate': json['endDate'] == null ? undefined : (new Date(json['endDate'])),
        'startDate': json['startDate'] == null ? undefined : (new Date(json['startDate'])),
        'resultEnd': json['resultEnd'] == null ? undefined : json['resultEnd'],
        'resultStart': json['resultStart'] == null ? undefined : json['resultStart'],
        'status': json['status'] == null ? undefined : LoyaltyRedemptionStatusFromJSON(json['status']),
        'gameId': json['gameId'] == null ? undefined : json['gameId'],
    };
}

export function SpinHistoryFiltersToJSON(value?: SpinHistoryFilters | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'endDate': value['endDate'] == null ? undefined : ((value['endDate']).toISOString()),
        'startDate': value['startDate'] == null ? undefined : ((value['startDate']).toISOString()),
        'resultEnd': value['resultEnd'],
        'resultStart': value['resultStart'],
        'status': LoyaltyRedemptionStatusToJSON(value['status']),
        'gameId': value['gameId'],
    };
}

